import React from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { LogOut, LayoutDashboard, Home as HomeIcon, MessageSquare, Building2, Inbox, Settings as SettingsIcon, CalendarDays } from "lucide-react";
import Logo from "../../components/Logo";
import { useAuth } from "../../context/AuthContext";
import { useI18n } from "../../i18n/I18nContext";

export default function AdminLayout({ children }) {
    const { logout, user } = useAuth();
    const { t } = useI18n();
    const navigate = useNavigate();

    const handleLogout = async () => {
        await logout();
        navigate("/admin/login");
    };

    const linkCls = ({ isActive }) =>
        `flex items-center gap-3 px-4 py-3 text-sm transition-colors ${
            isActive ? "bg-brand-gold text-white" : "text-white/80 hover:bg-white/5"
        }`;

    return (
        <div className="min-h-screen bg-brand-paper flex">
            <aside className="hidden md:flex w-64 bg-brand-navy text-white flex-col" data-testid="admin-sidebar">
                <div className="px-5 py-6 border-b border-white/10 bg-white/5">
                    <Logo light />
                </div>
                <nav className="flex-1 p-3 space-y-1">
                    <NavLink to="/admin" end className={linkCls} data-testid="admin-nav-dashboard">
                        <LayoutDashboard className="w-4 h-4" /> {t("admin.dashboard")}
                    </NavLink>
                    <NavLink to="/admin/inquiries" className={linkCls} data-testid="admin-nav-inquiries">
                        <Inbox className="w-4 h-4" /> {t("inquiries.title")}
                    </NavLink>
                    <NavLink to="/admin/bookings" className={linkCls} data-testid="admin-nav-bookings">
                        <CalendarDays className="w-4 h-4" /> {t("bookings_admin.title")}
                    </NavLink>
                    <NavLink to="/admin/properties" className={linkCls} data-testid="admin-nav-properties">
                        <Building2 className="w-4 h-4" /> {t("admin.properties")}
                    </NavLink>
                    <NavLink to="/admin/properties/new" className={linkCls} data-testid="admin-nav-new">
                        <HomeIcon className="w-4 h-4" /> {t("admin.new_property")}
                    </NavLink>
                    <NavLink to="/admin/messages" className={linkCls} data-testid="admin-nav-messages">
                        <MessageSquare className="w-4 h-4" /> {t("admin.messages")}
                    </NavLink>
                    <NavLink to="/admin/settings" className={linkCls} data-testid="admin-nav-settings">
                        <SettingsIcon className="w-4 h-4" /> {t("settings.title")}
                    </NavLink>
                </nav>
                <div className="p-3 border-t border-white/10">
                    <div className="text-xs text-white/60 px-2 mb-2">{user?.email}</div>
                    <button
                        onClick={handleLogout}
                        data-testid="admin-logout"
                        className="w-full inline-flex items-center gap-2 px-4 py-2.5 bg-white/10 hover:bg-brand-gold text-white text-[0.72rem] tracking-[0.22em] uppercase font-semibold transition-colors"
                    >
                        <LogOut className="w-4 h-4" /> {t("admin.logout")}
                    </button>
                    <Link to="/" className="block text-center mt-3 text-xs text-white/60 hover:text-brand-gold">
                        ← {t("nav.home")}
                    </Link>
                </div>
            </aside>
            <main className="flex-1 min-w-0">{children}</main>
        </div>
    );
}
